import React, { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { SelectionBoxContext } from './context';
import SelectionBoxItem from './SelectionBoxItem';

import styles from './SelectionBox.module.scss';

const SelectionBox = ({
  selected,
  vertical,
  onChange,
  selectionType,
  hideSelectionControl = false,
  children,
  size = 'sm',
  className,
}) => {
  const value = useMemo(
    () => ({
      selected,
      onChange,
      selectionType,
      vertical,
      hideSelectionControl,
      size,
    }),
    [size, selected, onChange, selectionType, vertical, hideSelectionControl],
  );

  return (
    <SelectionBoxContext.Provider value={value}>
      <div
        className={cx(
          styles.container,
          {
            [styles.orientationVertical]: vertical,
          },
          className,
        )}
        role="radiogroup"
      >
        {children}
      </div>
    </SelectionBoxContext.Provider>
  );
};

SelectionBox.propTypes = {
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  vertical: PropTypes.bool,
  onChange: PropTypes.func,
  selectionType: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  size: PropTypes.oneOf(['sm', 'lg']),
  hideSelectionControl: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string,
};

SelectionBox.Item = SelectionBoxItem;

export default SelectionBox;
